skrilla.controller('reportProductIntegrityDetailsCtrl', function ($scope, $stateParams, searchService, productIntegrityReportService) {

    searchService.get("productIntegrityReports/" + $stateParams.id, null, true).then(function(response){
        $scope.report = response.data;
        $scope.tableData = productIntegrityReportService.buildTableForEntries($scope.report.tag, $scope.report.entries, $scope.report.reportType);
    })

});
